export default __webpack_public_path__ + "static/media/success.b5a00e73.svg";